/**
 * Risk Monitor analytics actions
 */
export const RISK_MONITOR_ACTIONS = {
  SCENARIO_RUN: 'scenario_run',
  DRIVER_UPDATED: 'driver_updated',
  EARLY_WARNING_TRIGGERED: 'early_warning_triggered',
  MONTE_CARLO_RUN: 'monte_carlo_run',
  REPORT_GENERATED: 'report_generated',
  TAB_CHANGED: 'tab_changed',
} as const;
